import * as React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Box, CircularProgress } from '@mui/material';
import { AddButton } from '../button/button';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { useNavigate, useParams } from 'react-router-dom';
import { STATUS } from '../../utils/status';
import SnackbarNotification from '../snackbar/snackbarNotification';
import DeleteModal from '../modal/deleteModal';
import { setCreateUnallocateAnalyseStatus, setCreateUnallocateAnalyseStatusByTaskIDs, setCreateUnallocateVendorStatus, setCreateUnallocateVendorStatusByTaskIDs, unallocateAnalyseBulkVendor, unallocateAnalyseBulkVendorByTaskIds, unallocateBulkVendor, unallocateBulkVendorByTaskIds } from '../../redux/slices/vendorList';
import VendorUnallocationBody from './vendorUnallocationBody';
import VendorBulkUnallocationTable from './vendorBulkUnallocAnalyseTable';
import VendorUnallocationStepHeading from './vendorUnallocationHeading';
import ChooseTypeAllocation from '../uploadTask/chooseTypeAllocation';
import UploadFileVendorAllocation from '../vendorBulkAllocation/taskIdAllocationVendorUpload';
import { clearFile } from '../../redux/reducers/sheetAllocationType3';

interface SheetData {
  name: string;
  data: any[][];
}

export default function VendorUnallocationSteps() {
  const [activeStep, setActiveStep] = useState(0);
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const [openSubmitModal, setOpenSubmitModal] = useState(false);
  const createStatus = useSelector((state: RootState) => state.upload.createBulkAllocationStatus);
  // const createVendorStatus = useSelector((state: RootState)=> state.vendorList.createVendorStatus)
  const vendorUnallocationAnalyseStatus = useSelector((state: RootState) => state.vendorList.createAnalyseStatus)
  const vendorUnallocationAnalyseMessage = useSelector((state: RootState) => state.vendorList.unallocateAnalyseBulkVendorMessage)
  const vendorBulkUnallocationStatus = useSelector((state: RootState) => state.vendorList.unallocateBulkVendorStatus)
  const vendorBulkUnallocationMessage = useSelector((state: RootState) => state.vendorList.unallocateBulkVendorMessage)
  const fileType3 = useSelector((state: RootState) => state.fileAllocation.file)
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [formDataArray, setFormDataArray] = useState([{ vendor_id: '', task_count: '', type: '', status: "" }]);
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [sheets, setSheets] = useState<SheetData[]>([]);
  const createStatusTaskIds = useSelector((state: RootState) => state.vendorList.createVendorUnallocateStatusTaskIDs);
  const createVendorMessageTaskIDs = useSelector((state: RootState) => state.vendorList.createBulkVendorUnallocateMessageTaskIDs)
  const createVendorAnalyseStatus = useSelector((state: RootState) => state.vendorList.createAnalyseUnallocateStatusTaskIDs)
  const createVendorAnalyseMessage = useSelector((state: RootState) => state.vendorList.createAnalyseBulkVendorUnallocateMessageTaskIDs)

  const handleOpenSubmitModal = () => {
    setOpenSubmitModal(true);
  }

  const handleCloseSubmitModal = () => {
    setOpenSubmitModal(false);
  }

  const handleTypeClick = (type: string) => {
    setSelectedType(type);
  };

  React.useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  React.useEffect(() => {
    window.history.pushState(null, '', window.location.href);

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    const handleBeforeUnloadDialog = (event: PopStateEvent) => {
      event.preventDefault();
      window.history.pushState(null, '', window.location.href);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handleBeforeUnloadDialog);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handleBeforeUnloadDialog);
    };
  }, []);

  const handleDoubleClick = (step: number) => {
    setActiveStep(step);
  };

  const steps = ["Select Type", "Add Vendor", "Verify & Submit"];

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <ChooseTypeAllocation selectedType={selectedType || ''} onTypeClick={handleTypeClick}
            activeStep={activeStep}
            onDoubleClick={handleDoubleClick}
            allocationType={'vendorAllocation'}
            taskerType={'vendorAllocation'}
          />
        );

      case 1:
        if (selectedType === 'Type 3') {
          return <UploadFileVendorAllocation setSheets={setSheets} />;
        } else if (selectedType === 'Type 2') {
          return <VendorUnallocationBody formDataArray={formDataArray} setFormDataArray={setFormDataArray} />
        }
        return null;

      case 2:
        return (
          <VendorBulkUnallocationTable formDataArray={formDataArray} selectedType={selectedType || ''}/>
        );

      default:
        return null;
    }
  };

  const handleNext = () => {
    if (activeStep !== 2) {
      setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
    }
    if (activeStep === 1 && selectedType === 'Type 2') {
      const payload = {
        project_id: id,
        data: formDataArray.map((item) => ({
          vendor_id: item.vendor_id,
          task_count: Number(item.task_count),
          stage: Number(item.type),
          status: item.status ? item.status.split(", ") : []
        })),
      }
      dispatch(unallocateAnalyseBulkVendor(payload))
    }
    if (activeStep === 1 && selectedType === 'Type 3') {
      const formData = new FormData()
      formData.append("project_id", id || '')
      if (fileType3) {
        formData.append("file", fileType3);
      }
      dispatch(unallocateAnalyseBulkVendorByTaskIds(formData),
      )
    }
  }

  const handleUnallocate = () => {
    if (activeStep === 2 && selectedType === 'Type 2') {
      const payload = {
        project_id: id,
        data: formDataArray.map((item) => ({
          vendor_id: item.vendor_id,
          task_count: Number(item.task_count),
          stage: Number(item.type),
          status: item.status ? item.status.split(", ") : []
        })),
      }
      dispatch(unallocateBulkVendor(payload))
    }
    if (activeStep === 2 && selectedType === 'Type 3') {
      const formData = new FormData()
      formData.append("project_id", id || '')
      if (fileType3) {
        formData.append("file", fileType3);
      }
      dispatch(unallocateBulkVendorByTaskIds(formData),
      )
    }
    setOpenSubmitModal(false)
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  React.useEffect(() => {
    if (createStatusTaskIds === STATUS.SUCESS) {
      handleSnackbar(createVendorMessageTaskIDs, 'success');
      setTimeout(() => {
        navigate(`/project/${id}?tab=task`);
      }, 1000);
      dispatch(clearFile())
      dispatch(setCreateUnallocateVendorStatusByTaskIDs(STATUS.NOT_STARTED));
    }

    if (createStatusTaskIds === STATUS.FAILED) {
      handleSnackbar(createVendorMessageTaskIDs, 'error');
      dispatch(setCreateUnallocateVendorStatusByTaskIDs(STATUS.NOT_STARTED));
    }
  }, [createStatusTaskIds, navigate, dispatch]);

  React.useEffect(() => {
    if (vendorBulkUnallocationStatus === STATUS.SUCESS) {
      handleSnackbar(vendorBulkUnallocationMessage, 'success');
      setTimeout(() => {
        navigate(`/project/${id}?tab=task`);
      }, 1000);
      dispatch(setCreateUnallocateVendorStatus(STATUS.NOT_STARTED));
    }

    if (vendorBulkUnallocationStatus === STATUS.FAILED) {
      handleSnackbar(vendorBulkUnallocationMessage, 'error');
      dispatch(setCreateUnallocateVendorStatus(STATUS.NOT_STARTED));
    }
  }, [vendorBulkUnallocationStatus, navigate, dispatch]);

  React.useEffect(() => {
    if (vendorUnallocationAnalyseStatus === STATUS.SUCESS) {
      if (activeStep === 0) {
        setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
      }
    }

    if (vendorUnallocationAnalyseStatus === STATUS.FAILED) {
      handleSnackbar(vendorUnallocationAnalyseMessage, 'error');
    }
    return () => {
      if (vendorUnallocationAnalyseStatus === STATUS.SUCESS || vendorUnallocationAnalyseStatus === STATUS.FAILED) {
        dispatch(setCreateUnallocateAnalyseStatus(STATUS.NOT_STARTED));
      }
    };
  }, [vendorUnallocationAnalyseStatus, navigate, dispatch]);

  React.useEffect(() => {
    if (createVendorAnalyseStatus === STATUS.SUCESS) {
      if (activeStep === 1) {
        setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
      }
    }

    if (createVendorAnalyseStatus === STATUS.FAILED) {
      handleSnackbar(createVendorAnalyseMessage, 'error');
    }
    return () => {
      if (createVendorAnalyseStatus === STATUS.SUCESS || createVendorAnalyseStatus === STATUS.FAILED) {
        dispatch(setCreateUnallocateAnalyseStatusByTaskIDs(STATUS.NOT_STARTED));
      }
    };
  }, [createVendorAnalyseStatus, navigate, dispatch]);

  const handleBack = () => {
    setActiveStep((prevStep) => Math.max(prevStep - 1, 0));
  };

  const isNextDisabled = () => {
    if (activeStep === 1 && selectedType === 'Type 2') {
      return formDataArray.some((data) =>
        !data.vendor_id || !data.task_count || !data.type || !data.status
      );
    }
    if (activeStep === 0 && !selectedType) {
      return true;
    }
    if (activeStep === 1 && selectedType === 'Type 3' && fileType3 === null) {
      return true;
    }
    return false;
  };

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <section className="fixed top-0 inset-x-0 h-[10px] z-40 drop-shadow bg-[#F7F9FA]" style={{ marginLeft: '4%' }}>
        <VendorUnallocationStepHeading />
      </section>
      <section className="fixed top-0 inset-x-0 h-[88px] z-40 drop-shadow mt-44 ml-52 mb-56">
        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </section>
      <Box component="main" sx={{ flexGrow: 1, bgcolor: '#F7F9FA', p: '4rem' }}>
        <section
          style={{
            height: 'calc(100vh - 400px)',
            overflowY: 'auto',
            padding: '12px, 0px, 12px, 0px',
            marginBottom: '15rem',
            marginTop: '14rem',
            flexGrow: 1
          }}
        >
          {renderStepContent(activeStep)}
        </section>
      </Box>
      <section className="fixed bottom-0 inset-x-0 h-[58px] bg-white z-40 drop-shadow">
        <Box
          sx={{
            mt: '0.1rem',
            display: 'flex',
            justifyContent: 'flex-end',
            mr: '0.4rem'
          }}
        >
          {activeStep !== 0 && (
            <AddButton variant="contained" onClick={handleBack}>
              Previous
            </AddButton>
          )}

          <AddButton
            variant="contained"
            onClick={activeStep === steps.length - 1 ? handleOpenSubmitModal : handleNext}
            disabled={isNextDisabled() || vendorBulkUnallocationStatus === STATUS.PENDING || createStatusTaskIds === STATUS.PENDING}
                        startIcon={activeStep === steps.length - 1 && 
                                    (vendorBulkUnallocationStatus === STATUS.PENDING || createStatusTaskIds === STATUS.PENDING) ? (
                                    <CircularProgress size={20} />
                                  ) : null
                                }
          >
            {activeStep === steps.length - 1 ? 'Unallocate' : 'Next'}
          </AddButton>
        </Box>
      </section>
      <SnackbarNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      <DeleteModal
        open={openSubmitModal}
        onCancel={handleCloseSubmitModal}
        onConfirm={handleUnallocate}
        deleteText='Unallocate'
        isButtonLoading={createStatus === STATUS.PENDING}
      />
    </div>
  );
}